import {createSelector} from 'reselect'
import {idLoading as isPurchaseLoading} from '../components/purchaseLightBox/selectors'
import {isLoading} from '../selectors'

export const showLoadingMoire = createSelector(
    isLoading,
    isPurchaseLoading,
    (pageLoading, purchaseLoading) => pageLoading || purchaseLoading
)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/loadingMoire/selectors.js